import { PkButton, PkDivider, PkIcon } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo, useRef, useState } from 'react';

import { useHeaderOptions } from '../../model';
import { sendHeaderTracking } from '../../utils';
import Overlay from '../Overlay';

import { useWindowSize } from '@hooks/useWindowSize';
import Image from '@shared/Image';
import { LoginButton } from '@shared/LoginButton';
import { AUTH_FLOW_TYPE } from '@shared-types/idp.types';
import { imgBaseUrl } from '@utilities/WindowContext';

import * as styles from './styles.module.scss';

const CompetitionHeader = () => {
  const { options } = useHeaderOptions();
  const { isMobile } = useWindowSize();

  const overlayTriggerRef = useRef<HTMLPkButtonElement>(null);
  const [overlayOpen, setOverlayOpen] = useState(false);

  const toggleOverlay = (open: boolean) => {
    setOverlayOpen(open);
    sendHeaderTracking('all sections panel', open ? 'Open' : 'Close');
  };

  const handleOverlayTriggerClick = () => {
    toggleOverlay(!overlayOpen);
  };

  const handleOverlayClose = () => {
    toggleOverlay(false);
    overlayTriggerRef.current?.focus();
  };

  const handleLoginClick = () => {
    sendHeaderTracking('Login');
  };

  return (
    <div
      className={clsx(
        'pk-d--flex pk-justify-content--between pk-align-items--center pk-gap--l pk-w--100',
        styles.container,
        overlayOpen && ['pk-bg--background', styles.containerOpen],
      )}
    >
      <PkButton
        ref={overlayTriggerRef}
        highContrast
        appearance='text'
        onPkClick={handleOverlayTriggerClick}
        aria-expanded={overlayOpen}
      >
        <Image
          title='UEFA.COM'
          className={styles.logo}
          src={`${imgBaseUrl}/imgml/uefacom/elements/main-nav/uefa-logo` + '.svg'}
        />
        <PkIcon
          className='pk-ml--xs2'
          name={overlayOpen ? 'navigation-dropdown-up' : 'navigation-dropdown-indicator'}
          color='interaction-high-contrast'
        />
      </PkButton>
      <Overlay open={overlayOpen} onClose={handleOverlayClose} />
      <div className='pk-d--flex'>
        <LoginButton
          hideIfLogged={false}
          type={AUTH_FLOW_TYPE.LOGIN}
          appearance='text'
          showUsername
          customUserPage={options.customUserPage}
          onClick={handleLoginClick}
        />
        {!isMobile && (
          <div className={clsx(styles.close, overlayOpen && styles.isOpen)}>
            <PkDivider className={clsx(styles.divider, 'pk-mx--m')} direction='vertical' />
            <PkButton
              soft
              appearance='icon'
              onPkClick={handleOverlayClose}
              tabIndex={overlayOpen ? undefined : -1}
              aria-hidden={!overlayOpen}
            >
              <PkIcon name='navigation-close' title='close' />
            </PkButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(CompetitionHeader);
